/**
 * Google Maps Migration Utilities
 * Handles deprecation warnings and provides migration guidance
 */

/**
 * Check if Advanced Marker is available
 */
export const isAdvancedMarkerAvailable = () => {
  return typeof window !== 'undefined' && 
         window.google && 
         window.google.maps && 
         window.google.maps.marker && 
         window.google.maps.marker.AdvancedMarkerElement
}

/**
 * Get migration guide for deprecated features
 */
export const getMigrationGuide = () => {
  return {
    marker: {
      deprecated: 'google.maps.Marker',
      recommended: 'google.maps.marker.AdvancedMarkerElement',
      migrationUrl: 'https://developers.google.com/maps/documentation/javascript/advanced-markers/migration',
      deprecationUrl: 'https://developers.google.com/maps/deprecations'
    }
  }
}

/**
 * Example of how to migrate from deprecated Marker to AdvancedMarkerElement
 */
export const migrateMarkerExample = () => {
  if (!isAdvancedMarkerAvailable()) {
    console.warn('Advanced Marker not available, using legacy Marker')
    return null
  }

  return {
    old: `
// Old deprecated way
const marker = new google.maps.Marker({
  position: { lat: -34.397, lng: 150.644 },
  map: map,
  title: 'Hello World!'
})
    `,
    new: `
// New recommended way
const marker = new google.maps.marker.AdvancedMarkerElement({
  position: { lat: -34.397, lng: 150.644 },
  map: map,
  title: 'Hello World!'
})
    `
  }
}

/**
 * Check for deprecated Google Maps usage in the application
 */
export const checkForDeprecatedMarkers = () => {
  const warnings = []
  
  // Check if any legacy markers are being used
  if (typeof window !== 'undefined' && window.google && window.google.maps) {
    // This is a basic check - in a real application, you'd want to scan your codebase
    console.log('🔍 Checking for deprecated Google Maps usage...')
    
    // Log migration guide
    const guide = getMigrationGuide()
    console.log('📚 Migration Guide:', guide)
    
    if (!isAdvancedMarkerAvailable()) {
      warnings.push('Advanced Marker not available - consider updating Google Maps API')
    }
  }
  
  return warnings
}

/**
 * Optimize Google Maps loading
 */
export const optimizeGoogleMapsLoading = () => {
  // Add loading=async to Google Maps script tags
  const scripts = document.querySelectorAll('script[src*="maps.googleapis.com"]')
  scripts.forEach(script => {
    if (!script.src.includes('loading=async')) {
      console.log('⚠️ Google Maps script should include loading=async for better performance')
    }
  })
}

/**
 * Initialize migration utilities
 */
export const initializeMigrationUtils = () => {
  // Check for deprecated usage on load
  setTimeout(() => {
    checkForDeprecatedMarkers()
    optimizeGoogleMapsLoading()
  }, 1000)
  
  // Log migration guide
  console.log('🗺️ Google Maps Migration Guide:', getMigrationGuide())
}
